import { render, staticRenderFns } from "./CollectMushrooms.vue?vue&type=template&id=41d901cb&"
import script from "./CollectMushrooms.vue?vue&type=script&lang=ts&"
export * from "./CollectMushrooms.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports